import { ShieldCheck } from "lucide-react";

export default function CommandHeader() {
  return (
    <header
      className="fixed top-0 inset-x-0 z-50 border-b border-white/5 glass"
      data-testid="command-header"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3" data-testid="brand-mark">
          <div className="relative w-9 h-9 grid place-items-center rounded-md border border-gold/40 bg-black">
            <ShieldCheck className="w-4 h-4 text-gold" strokeWidth={1.6} />
            <span className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-violet animate-pulse-violet" />
          </div>
          <div className="leading-tight">
            <div className="font-heading text-[15px] tracking-[0.18em] text-white">
              NESSA RESCUE NODE
            </div>
            <div className="font-mono text-[9px] tracking-[0.3em] text-gold/80 uppercase">
              Sovereign Lifestyle Hub
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div
            className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full border border-violet/30 bg-violet/5"
            data-testid="encryption-status"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-violet animate-pulse-violet" />
            <span className="font-mono text-[10px] tracking-[0.28em] text-violet-soft uppercase">
              Encrypted · 25D
            </span>
          </div>
          <div
            className="hidden md:block font-mono text-[10px] tracking-[0.28em] text-white/40 uppercase"
            data-testid="node-id"
          >
            NODE/0x7FA · SECURE
          </div>
        </div>
      </div>
    </header>
  );
}
